import React from "react"
import PropTypes from "prop-types"

export interface WithPerkOrReward {
  isPerks?: boolean
  isRewards?: boolean
  isWallet?: boolean
  isRecognition?: boolean
}

const withPerkOrReward = <P extends WithPerkOrReward>(Comp: React.ComponentClass<P> | React.FC<P>) => {
  const component = ({...props}, {appPath, apps}) => {
    const {ADMIN, FLEXIREWARDS, PERKS, SEARCH, WALLET, RECOGNITION} = apps
    const isNonWalletAdminDeal = appPath === ADMIN && !props.useWalletDealCard

    if (appPath === RECOGNITION) {
      return <Comp {...(props as P)} isRecognition />
    }
    if (appPath === PERKS || isNonWalletAdminDeal) {
      return <Comp {...(props as P)} isPerks />
    }
    if (appPath === FLEXIREWARDS) {
      return <Comp {...(props as P)} isRewards />
    }
    if (appPath === WALLET || appPath === ADMIN) {
      return <Comp {...(props as P)} isRewards isWallet />
    }
    if (appPath === SEARCH) {
      const {pathname} = window.location
      const isRewards = pathname === `${SEARCH}/rewards`
      return <Comp {...(props as P)} isPerks={!isRewards} isRewards={isRewards} />
    }
    return <Comp {...(props as P)} />
  }
  component.contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }
  return component
}

export default withPerkOrReward
